import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { paymentTermActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const PaymentTerms = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const paymentTerms = useSelector((state) => state.paymentTerms);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "code",
      headerName: "Internal Code",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "name",
      headerName: "Displayed Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(paymentTermActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {paymentTerms && (
        <DataTable
          loading={paymentTerms?.loading}
          rows={paymentTerms?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="paymentTermActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default PaymentTerms;